import "firebase/functions";

import { appConfig, pad } from "../../../utils";

import firebase from "firebase/app";

export const addSafetyReviewBoardMeetingForm = ({ form, store, router, db }) => {
    form.setConfig({
        "title": "Add Safety Review Board Meeting",
        "type": "push",
        "location": "SafetyManagement/SafetyReviewBoardMeetings",
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return `${appConfig.docPrefix}SRB-${pad(store.state.counts.srb.count)}`
            }
        }, {
            "label": "Title",
            "name": "Title",
            "type": "text",
        }, {
            "label": "Date of Meeting",
            "name": "Date[Meeting]",
            "type": "date",
            "required": true
        }, {
            "label": "Meeting Minutes",
            "name": "MeetingMinutes",
            "type": "file",
            "required": true
        }],
        async preSubmitHook({ data, db }) {
            const number = await db.utils.allocateCount("counts/srb/count");
            return {
                "Number": `${appConfig.docPrefix}SRB-${pad(number)}`,
                "Date" : { "Created": new Date().toISOString(), "Meeting": new Date(data.Date.Meeting).toISOString() },
            }
        },
        async postSubmitHook({ files, typeRef }) {
            for (const file of files) {
                await db.upload(`Database/SafetyReviewBoardMeetings/${typeRef.key}/MeetingMinutes`, file[0]);
            }

            await db.update(`SafetyManagement/SafetyReviewBoardMeetings/${typeRef.key}/`, {
                "MeetingMinutesFile": files[0][0].name,
            });

            return;
        }
    });
    form.toggle();
};

export const generateSafetyReviewBoardMeetingSummary = async ({ pageItem, toast }) => {
    try {
        if (!pageItem?.ID) {
            toast.error("Unable to generate summary: meeting ID is missing.");
            return;
        }

        if (!pageItem?.MeetingMinutesFile) {
            toast.error("Unable to generate summary: meeting minutes PDF is missing.");
            return;
        }

        toast.info("Generating summary. This may take a moment...");
        const summarizeMeeting = firebase.app().functions().httpsCallable("summarizeSafetyReviewBoardMeeting");
        await summarizeMeeting({ meetingId: pageItem.ID });
        toast.success("Summary generated successfully.");
    } catch (error) {
        console.error("[SRB][Summary] Callable failed", error);
        toast.error(error?.message || "Failed to generate summary.");
    }
};
